module.exports = __webpack_public_path__ + "datedropper.a6ae7fb2d30b2b853b4b.svg";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/plugin/datedropper/src/datedropper.svg
// module id = ../../../../../src/assets/plugin/datedropper/src/datedropper.svg
// module chunks = styles